import {styled} from "@mui/material/styles"

export const StandardFacetListLabelWrapper = styled("div")`
    && {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 2.75rem;
        padding: 0 1rem;
        background-color: ${({theme}) => theme.colours.popover.header.backgroundColour};
    }
`

export default StandardFacetListLabelWrapper
